import { action } from "@storybook/addon-actions";
import { ComponentMeta, ComponentStory } from "@storybook/react";
import React from "react";
import Flex from "../Flex";
import { ExternalLinkButton, ExternalLinkButtonProps } from "./ExternalLinkButton";

const commonArgs: ExternalLinkButtonProps = {
    trackName: "button",
    loading: false,
    title: "Button CTA",
    onClick: action("clicked")
};

export default {
    title: "common/Buttons/ExternalLinkButton",
    component: ExternalLinkButton,
    args: commonArgs
} as ComponentMeta<typeof ExternalLinkButton>;

const Template: ComponentStory<typeof ExternalLinkButton> = args => {
    return (
        <Flex spacing={1} alignItems="center">
            <ExternalLinkButton {...args} size="lg" />
            <ExternalLinkButton {...args} size="md" />
            <ExternalLinkButton {...args} size="sm" />
        </Flex>
    );
};

export const Text = Template.bind({});

export const TextIcon = Template.bind({});
TextIcon.args = {
    icon: true
};

export const TextLoading = Template.bind({});
TextLoading.args = {
    loading: true
};

export const DestructiveText = Template.bind({});
DestructiveText.args = {
    destructive: true
};

export const DestructiveTextIcon = Template.bind({});
DestructiveTextIcon.args = {
    ...DestructiveText.args,
    icon: true
};

export const DestructiveTextLoading = Template.bind({});
DestructiveTextLoading.args = {
    ...DestructiveText.args,
    loading: true
};

export const WithTooltip = Template.bind({});
WithTooltip.args = {
    tooltip: "Tooltip text"
};
